export var CharacterLoadingStatusEnum;
(function (CharacterLoadingStatusEnum) {
    CharacterLoadingStatusEnum["NOT_INITIALIZED"] = "NOT_INITIALIZED";
    CharacterLoadingStatusEnum["LOADING"] = "LOADING";
    CharacterLoadingStatusEnum["LOADED"] = "LOADED";
    CharacterLoadingStatusEnum["ERROR"] = "ERROR";
})(CharacterLoadingStatusEnum || (CharacterLoadingStatusEnum = {}));
